import { create } from "../../../../../common/utils/zustand_state_manager";

/**
 * useClientesListaFilters
 */

type State = {
    idsCentroCusto?: number[];
    nomeFantasia?: string;
    cnpj?: string;
    cpf?: string;
    nome?: string;
    unidade?: string;
};

type Action = {
    setNomeFantasia: (nomeFantasia: string | undefined) => void;
    setCnpj: (cnpj: string | undefined) => void;
    setCpf: (cpf: string | undefined) => void;
    setNome: (nome: string | undefined) => void;
    setUnidade: (unidade: string | undefined) => void;
    setIdsCentroCusto: (list: number[]) => void;
    clearFilters: () => void;
};

export const useClientesListaFilters = create<State & Action>((set) => ({
    idsCentroCusto: [],
    nomeFantasia: undefined,
    cnpj: undefined,
    cpf: undefined,
    nome: undefined,
    unidade: undefined,
    setCnpj: (cnpj) => set({ cnpj }),
    setCpf: (cpf) => set({ cpf }),
    setNomeFantasia: (nomeFantasia) => set({ nomeFantasia }),
    setNome: (nome) => set({ nome }),
    setUnidade: (unidade) => set({ unidade }),
    setIdsCentroCusto: (list) => set({ idsCentroCusto: list }),
    clearFilters: () => set({
        idsCentroCusto: [],
        nomeFantasia: '',
        cnpj: '',
        cpf: '',
        nome: '',
        unidade: '',
    }),
}));

export const initialClientesListaFiltersValues: State = {
    idsCentroCusto: [],
    nomeFantasia: '',
    cnpj: '',
    cpf: '',
    nome: '',
    unidade: '',
};